import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;

class App extends Component {
  // Функция для форматирования ячейки с учетом длинных значений
  formatCellValue = (value, unit) => {
    // Если значение пустое, возвращаем прочерк
    if (!value) return '-';
    
    // Проверяем, является ли единица измерения длинной строкой (содержит пробелы или слова)
    const isLongUnit = unit && (unit.includes(' ') || unit.length > 10);
    
    if (isLongUnit) {
      // Для длинных единиц измерения делаем перенос: значение сверху, единица измерения снизу
      return (
        <>
          {value}<br />
          <span className='text-[#032432]/60 text-[14px] xl:text-[16px]'>{unit}</span>
        </>
      );
    } else {
      // Для коротких единиц измерения оставляем в одной строке
      return (
        <>
          {value} <span className='text-[#032432]/60'>{unit}</span>
        </>
      );
    }
  };

  render() {

    const data = this.props?.data || {}
    const upakovka = data?.upakovka || {}
    const rows = upakovka?.rows || []

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center gap-[12px] text-[14px] xl:text-[16px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.02539 6.94482L9.00038 9.24732L12.9454 6.95982" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.00195 13.3272V9.23975" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.0697 4.71739L5.66969 6.05239C5.12969 6.35239 4.67969 7.10989 4.67969 7.73239V10.2749C4.67969 10.8974 5.12219 11.6549 5.66969 11.9549L8.0697 13.2899C8.5797 13.5749 9.41969 13.5749 9.93719 13.2899L12.3372 11.9549C12.8772 11.6549 13.3272 10.8974 13.3272 10.2749V7.72489C13.3272 7.10239 12.8847 6.34489 12.3372 6.04489L9.93719 4.70989C9.41969 4.42489 8.5797 4.42489 8.0697 4.71739Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Упаковка</div>
            </div>
            <img className='xl:hidden' width="38" height="38" alt="logo" src={data?.slogo} />
          </div>
          <div className='flex justify-between items-center mt-[20px] xl:mt-[30px]'>
            <div>
              <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(upakovka?.title)}</h2>
              <div className='mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-center xl:text-start text-black/60'>{Parser(upakovka?.text)}</div>
            </div>
            <img className='hidden xl:block' width="74" height="74" alt="logo" src={data?.slogo} />
          </div>
          <div className='mt-[20px] flex items-start gap-[8px] overflow-x-auto overflow-y-hidden pb-[10px] xl:pb-0 w-[clac(100%+10px)] xl:w-full'>
            {/* Первая таблица - Вид/Упаковка/Литраж */}
            <div className='w-[341px]'>
              <div className='rounded-[15px] bg-[#F5F7F9] overflow-hidden'>
                <table className="table-auto w-full">
                  <thead>
                    <tr className='bg-[#009EE3] h-[54px]'>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>Вид</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>Упаковка (ДxВxШ)</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>Литраж</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={`row1-${index}`} className='even:bg-[#E8ECF0]'>
                        <td>
                          <div className='h-[80px] w-[70px] flex items-center justify-center'>
                            <img src={row.image} alt={row.upak} width={38} height={52} />
                          </div>
                        </td>
                        <td className='text-[16px] xl:text-[18px] text-[#032432]'>
                          {row.upak}<br />
                          <span className='text-[#032432]/60'>{row.dvh}</span>
                        </td>
                        <td className='text-black/60 text-[14px] xl:text-[16px] w-[90px] text-right pr-[20px]'>
                          {row.litraz} {row.litrazed}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='text-center w-full mt-[20px] text-[16px] xl:text-[18px]'>Таблица паллетирования канистр</div>
            </div>

            {/* Вторая таблица - Для маркетплейсов */}
            <div className='w-[411px]'>
              <div className='rounded-[15px] bg-[#F5F7F9] overflow-hidden'>
                <table className="table-auto w-full">
                  <thead>
                    <tr className='bg-[#009EE3] h-[54px]'>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>1 ряд</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>2 ряд</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>3 ряд</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>Высота</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={`row2-${index}`} className='even:bg-[#E8ECF0] text-center'>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] h-[82px] align-middle'>
                          {this.formatCellValue(row.rad1, row.rad1ed)}
                        </td>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] align-middle'>
                          {this.formatCellValue(row.rad2, row.rad2ed)}
                        </td>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] align-middle'>
                          {this.formatCellValue(row.rad3, row.rad3ed)}
                        </td>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] align-middle'>
                          {row.height} <span className='text-[#032432]/60'>{row.heighted}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='text-center w-full mt-[20px] text-[16px] xl:text-[18px]'>Паллет <span className='text-black/60'>800x1200мм</span> для маркетплейсов</div>
            </div>

            {/* Третья таблица - Стандартный паллет */}
            <div className='flex-1'>
              <div className='rounded-[15px] bg-[#F5F7F9] overflow-hidden'>
                <table className="table-auto w-full">
                  <thead>
                    <tr className='bg-[#009EE3] h-[54px]'>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>1 ряд</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>2 ряд</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>3 ряд</th>
                      <th className='font-normal text-white text-[16px] xl:text-[18px] px-[10px] xl:px-0'>Высота</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={`row3-${index}`} className='even:bg-[#E8ECF0] text-center'>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] h-[82px] align-middle'>
                          {this.formatCellValue(row.rad12, row.rad12ed)}
                        </td>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] align-middle'>
                          {this.formatCellValue(row.rad22, row.rad22ed)}
                        </td>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] align-middle'>
                          {this.formatCellValue(row.rad32, row.rad32ed)}
                        </td>
                        <td className='text-[#032432] text-[16px] xl:text-[18px] align-middle'>
                          {row.height2} <span className='text-[#032432]/60'>{row.heighted2}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='text-center w-full mt-[20px] text-[16px] xl:text-[18px]'>Паллет <span className='text-black/60'>800x1200мм</span></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;